import { subDays } from "date-fns";
import { DatePeriod } from "./DatePeriod";
import { isMonth, Month } from "./Month";

function newYearsYear() {
  return subDays(new Date(), 5).getFullYear(); // This allows the date to reach 5. january before switching to 2026.
}

/**
 * Special dates
 */
export const newYearsPeriod = new DatePeriod({
  from: new Date(newYearsYear(), Month.December, 31, 18),
  to: new Date(newYearsYear() + 1, Month.January, 1, 6),
});

export function hasNewYearsEvePeriod(periods: Array<DatePeriod>) {
  for (const period of periods) {
    if (isNewYearsEve(period.from) || isNewYearsEve(period.to)) return true;
  }
  return false;
}

export function isNewYearsEve(d: Date) {
  return newYearsPeriod.isWithin(d);
}

export function isNewYearsDay(d: Date) {
  return isMonth(Month.December, d) && d.getDate() === 31;
}

export function isFirstOfJanuary(d: Date) {
  return isMonth(Month.January, d) && d.getDate() === 1;
}
